export * from './src/ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';
